// Resume on the first card not revealed yet; the first card once all are.
export const firstUnrevealedIndex = (revealed: number[], total: number) => {
  for (let i = 0; i < total; i++) {
    if (!revealed.includes(i)) return i;
  }
  return 0;
};
